import { transformDateValue } from 'core/js/FormUtils';
export const getMfprintingtypeView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mfprintingtypeList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mfprintingtypeList.push(card);
  })
  return mfprintingtypeList;
}